import React from 'react';
import Translator from 'translator';
import { OrderedMap } from 'immutable';
import { SvgUser, SvgTicket, SvgHome, SvgManagement, SvgCraftsman, SvgProduct, SvgBox } from 'data/common/iconsvg';
import BookmarkIcon from '@material-ui/icons/Bookmark';

export default env =>
    OrderedMap({
        homesList: {
            key: 0,
            label: Translator.translate('general.Homes'),
            path: 'home',
            right: 'homeList',
            Icon: SvgHome,
        },
        managementsList: {
            key: 1,
            label: Translator.translate('general.Residences'),
            path: 'management',
            right: 'managementList',
            Icon: SvgManagement,
        },
        productsList: {
            key: 2,
            label: Translator.translate('general.Products'),
            path: 'products',
            right: 'productsList',
            Icon: SvgProduct,
        },
        brandsList: {
            key: 3,
            label: Translator.translate('general.brands'),
            path: 'brands',
            right: 'homeList',
            Icon: () => <BookmarkIcon fontSize="large" color={"primary"} />,
        },
        userManagerList: {
            key: 4,
            label: Translator.translate('general.UsersManager'),
            path: 'user-manager',
            right: 'userManagerList',
            Icon: SvgUser,
        },
        fheticketList: {
            key: 5,
            label: Translator.translate('general.Ticketing'),
            path: 'fheticket',
            right: 'fheTicketList',
            Icon: SvgTicket,
        },
        boxesList: {
            key: 6,
            label: Translator.translate(`${env}.centerName`),
            path: 'box',
            right: `boxList_${env}`,
            Icon: SvgBox,
        },
        ticketsgitsList: {
            key: 7,
            label: Translator.translate('general.ticketsgit'),
            path: 'issues',
            right: 'issuesList',
            Icon: SvgTicket,
        },
        pushNotificationList: {
            key: 8,
            label: Translator.translate('general.PushNotification'),
            path: 'push-notifications',
            right: 'pushNotificationList',
            Icon: SvgTicket,
        },
    });



// WEBPACK FOOTER //
// ./environments/genericEnv/common/subMenuData.js